import React from "react";
import classes from "./QuizDetail.module.scss";
import Header from "../../molecules/header/Header";
import TeacherComment from "../../molecules/teacher-commnet/TeacherComment";
import rabbitNormal from "../../static/images/rabbit-normal.png";
import SimpleButton from "../../atoms/simple-button/SimpleButton";
import QuizHeader from "../../molecules/bar-header/BarHeader";
import { useLocation, useNavigate } from "react-router-dom";
import BreadCrumb from "../../molecules/breadcrumb/BreadCrumb";
import { useAtom } from "jotai";
import { selectQuizAtom } from "../../atoms/quiz/Quiz";

const QuizDetail = () => {
  const [quiz] = useAtom(selectQuizAtom);
  const navigate = useNavigate();
  return (
    <>
      <div className={classes.container}>
        <Header />
        <QuizHeader title="◯×クイズ" />
        <div className={classes.quizContainer}>
          <div className={classes.actionSubtitle}>{quiz?.tag}</div>
          <div className={classes.actionTitle}>{quiz?.title}</div>
          <div className={classes.badgeContainer}>
            <img
              className={classes.acquiredBadgeType}
              src={quiz?.image}
              alt={quiz?.image}
            />
          </div>
          <TeacherComment
            image={rabbitNormal}
            comment={[
              "問題は全部で10問！すべて回答するとバッジがもらえます",
              "再挑戦は何度でも可能です♪",
            ]}
          />
          <div className={classes.button}>
            <SimpleButton
              label="◯×クイズ スタート"
              width="100%"
              onClick={() => navigate(`/quiz-answer?quizId=${quiz?.quizId}`)}
            ></SimpleButton>
          </div>
        </div>
      </div>
      <div className={classes.breadCrumb}>
        <BreadCrumb
          data={[
            { displayName: "みらいいコンシェル", url: "/top" },
            { displayName: "◯×クイズ一覧", url: "/quiz" },
            { displayName: `${quiz?.title}` },
          ]}
        />
      </div>
    </>
  );
};

export default QuizDetail;
